import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "sentinel", "indicator" ]
  static values = { url: String }

  connect() {
    this.isLoading = false
    this.hasSeenSentinelOutsideViewport = false
    this.allowImmediateLoad = document.documentElement.scrollHeight <= (window.innerHeight + 16)
    this.hideLoading()

    if (!this.hasSentinelTarget || !this.hasUrlValue || !this.urlValue) return

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      { root: null, rootMargin: "200px 0px", threshold: 0 }
    )
    this.observer.observe(this.sentinelTarget)
  }

  disconnect() {
    this.teardownObserver()
  }

  handleIntersect(entries) {
    if (this.isLoading) return

    const isVisible = entries.some((entry) => entry.isIntersecting)
    if (!isVisible) {
      this.hasSeenSentinelOutsideViewport = true
      return
    }

    if (!this.allowImmediateLoad && !this.hasSeenSentinelOutsideViewport) return

    this.isLoading = true
    this.teardownObserver()
    this.showLoading()
    this.loadMore()
  }

  teardownObserver() {
    if (!this.observer) return

    this.observer.disconnect()
    this.observer = null
  }

  async loadMore() {
    try {
      const response = await fetch(this.urlValue, {
        method: "GET",
        headers: { "Accept": "text/html" },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error(`Failed to load more shared inloops (${response.status})`)

      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const nextRoot = doc.querySelector("[data-shared-inloops-root]")
      const currentRoot = this.element.closest("[data-shared-inloops-root]")

      if (!nextRoot || !currentRoot) throw new Error("Shared inloops root not found")

      currentRoot.replaceWith(nextRoot)
    } catch (error) {
      // Keep current UI on failure and allow retry on next intersection.
      console.error(error)
      this.isLoading = false
      this.hideLoading()

      if (this.hasSentinelTarget) {
        this.observer = new IntersectionObserver(
          this.handleIntersect.bind(this),
          { root: null, rootMargin: "200px 0px", threshold: 0 }
        )
        this.observer.observe(this.sentinelTarget)
      }
    }
  }

  showLoading() {
    if (!this.hasIndicatorTarget) return

    this.indicatorTarget.classList.remove("hidden")
    this.indicatorTarget.classList.add("flex")
  }

  hideLoading() {
    if (!this.hasIndicatorTarget) return

    this.indicatorTarget.classList.add("hidden")
    this.indicatorTarget.classList.remove("flex")
  }
}
